import styled from 'styled-components';
import { StyledButton, withTheme } from '@canopysecurity/component-library';
import { LoadingButton } from '@mui/lab';

export const ButtonContainer = withTheme(styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${({ theme }) => theme.background.surface};
  border-radius: ${({ theme }) => theme.radii.radiusLarge};
`);

export const ActionButton = styled(StyledButton).attrs(() => ({
  style: {
    flex: 1,
    height: '40px',
    margin: '0 10px',
  },
}))``;

export const StyledLoadingButton = styled(LoadingButton)`
  color: ${({ theme }) => theme.primary.main};
  border-color: ${({ theme }) => theme.primary.main};
`;
